<template>
  <CAlert color="warning" class="py-2 px-2">
    <CRow class="align-items-center" v-if="canBuy">
      <CCol>
        <div class="d-flex justify-content-start align-items-center text-warning font-sm">
          <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
          {{ $t('campaign.campaignSummary.text.insuficienteBalance') }}
        </div>
      </CCol>
      <CCol class="text-right">
        <CButton color="primary" class="px-4 py-1 font-xs" @click="redirectToBuy()">
          {{ $t('campaign.campaignSummary.button.buyCredit') }}
        </CButton>
      </CCol>
    </CRow>
    <CRow class="align-items-center" v-else>
      <CCol sm="12">
        <div class="d-flex justify-content-start align-items-center text-warning font-sm">
          <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
          {{ textSupport }}
        </div>
      </CCol>
    </CRow>
  </CAlert>
</template>

<script>
export default {
  methods: {
    redirectToBuy() {
      this.$router.push({ name: 'manage-balance' })
    },
  },

  computed: {
    canBuy() {
      const organizationBalanceConfigType = this.$store.state.auth.session.organization.organizationBalanceConfigType
      const planType = this.$store.state.auth.session.organization.planType

      if (planType == 4 || organizationBalanceConfigType == 1 || organizationBalanceConfigType == 2) {
        return false
      }

      return true
    },

    textSupport() {
      const organizationBalanceConfigType = this.$store.state.auth.session.organization.organizationBalanceConfigType
      const planType = this.$store.state.auth.session.organization.planType

      if (organizationBalanceConfigType == 1 || organizationBalanceConfigType == 2) {
        return this.$t('campaign.campaignSummary.text.contactAccountManager')
      }
      if (planType == 4) {
        return this.$t('campaign.campaignSummary.text.contactSupport')
      }

      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.font-sm {
  font-size: $font-size-xs;
  font-weight: 700;
}

.font-xs {
  font-size: $font-size-xs1;
  font-weight: 600;
}
</style>
